module.exports = __webpack_public_path__ + "img/reports_light.10b6fe6d.svg";